import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import FilterMenu from "./filter-menu";
import AddArea from "./modal-add-area";
import EditArea from "./modal-edit-area";
import "../../../../assets/css/style-table.css";
import { useSearchParams } from "react-router-dom";

const { confirm } = Modal;

const Area = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dataArea, setDataArea] = useState([]);
  const [dataAreaFilter, setDataAreaFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const getArea = async (query) => {
    const queryString = new URLSearchParams(query).toString();
    state.LOADING = true;

    await API.Get(`area/map${query ? "?" + queryString : ""}`)
      .then((result) => {
        let dataArea = [];

        result?.data.forEach((warehouse) => {
          warehouse.rows.forEach((row) => {
            row.sections.forEach((section) => {
              section.columns.forEach((column) => {
                column.levels.forEach((level) => {
                  dataArea.push({
                    warehouse_id: warehouse.warehouse_id,
                    warehouse_name: warehouse.warehouse_name,
                    section: section.section,
                    row_number: row.row_number,
                    column_name: column.column_name,
                    area_id: level.id,
                    name: level.name,
                    level: level.level,
                    status: level.status,
                    occupied_areas: section.occupied_areas,
                    empty_areas: section.empty_areas,
                    total_weight: section.total_weight,
                  });
                });
              });
            });
          });
        });

        setDataArea(dataArea);
        setDataAreaFilter(dataArea);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Area Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    const query = Object.fromEntries([...searchParams.entries()]);
    getArea(query);
  }, [searchParams]);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`area/${data.area_id}`)
          .then(() => {
            message.success("Area has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Area");
            console.error(err);
          })
          .finally(() => {
            onGetArea();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Warehouse",
      dataIndex: "warehouse_name",
      key: "warehouse_name",
      sorter: (a, b) => {
        if (a.warehouse_name === null || a.warehouse_name === "-") return 1;
        if (b.warehouse_name === null || b.warehouse_name === "-") return -1;
        return a.warehouse_name.localeCompare(b.warehouse_name);
      },
      render: (warehouse_name) => (warehouse_name ? warehouse_name : "-"),
    },
    {
      title: "Section",
      dataIndex: "section",
      key: "section",
      sorter: (a, b) => {
        if (a.section === null || a.section === "-") return 1;
        if (b.section === null || b.section === "-") return -1;
        return a.section.localeCompare(b.section);
      },
      render: (section) => (section ? section : "-"),
    },
    {
      title: "Row Number",
      dataIndex: "row_number",
      key: "row_number",
      sorter: (a, b) => {
        if (a.row_number === null || a.row_number === "-") return 1;
        if (b.row_number === null || b.row_number === "-") return -1;
        return a.row_number - b.row_number;
      },
      render: (row_number) => (row_number ? row_number : "-"),
    },
    {
      title: "Column Name",
      dataIndex: "column_name",
      key: "column_name",
      sorter: (a, b) => {
        if (a.column_name === null || a.column_name === "-") return 1;
        if (b.column_name === null || b.column_name === "-") return -1;
        return a.column_name.localeCompare(b.column_name);
      },
      render: (column_name) => (column_name ? column_name : "-"),
    },
    {
      title: "Area ID",
      dataIndex: "area_id",
      key: "area_id",
      sorter: (a, b) => {
        if (a.area_id === null || a.area_id === "-") return 1;
        if (b.area_id === null || b.area_id === "-") return -1;
        return a.area_id - b.area_id;
      },
      render: (area_id) => (area_id ? area_id : "-"),
    },
    {
      title: "Area Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => {
        if (a.name === null || a.name === "-") return 1;
        if (b.name === null || b.name === "-") return -1;
        return a.name.localeCompare(b.name);
      },
      render: (name) => (name ? name : "-"),
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      sorter: (a, b) => {
        if (a.level === null || a.level === "-") return 1;
        if (b.level === null || b.level === "-") return -1;
        return a.level - b.level;
      },
      render: (level) => (level ? level : "-"),
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataArea.filter((area) =>
      area.name.toLowerCase().includes(val.toLowerCase())
    );

    setDataAreaFilter(data);
  };

  const onClear = async (val) => {
    const query = Object.fromEntries([...searchParams.entries()]);
    getArea(query);
  };

  const onGetArea = async (val) => {
    const query = Object.fromEntries([...searchParams.entries()]);
    getArea(query);
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <FilterMenu onShowAdd={onShowAdd} onSearch={onSearch} onClear={onClear} />

      {/* Area Table */}
      <Table
        rowKey={(dataSource) => dataSource.area_id}
        columns={columns}
        dataSource={dataAreaFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add Area */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddArea
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetArea={onGetArea}
        />
      </div>

      {/* Modal Edit Area */}
      <EditArea
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetArea={onGetArea}
        selectedData={selectedData}
      />
    </>
  );
};

export default Area;
